import React,{useState} from 'react';
import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';
import { useStateContext } from '../../contexts/ContextProvider';
import { Button} from '../../components';
import { subMonths, startOfMonth } from 'date-fns';
import { getDocumentosMatriz } from "../../services/Documentos";
import { exportToExcel } from 'react-json-to-excel';
import { toast } from 'react-hot-toast';

const ReporteDocumentos = () => {
  const { currentColor, currentMode } = useStateContext();
  const [selectedDate, setSelectedDate] = useState(getFirstDayOfMonth('Inicio')); // Fecha inicial
  const [selectedDateEnd, setSelectedDateEnd] = useState(getFirstDayOfMonth('Fin')); // Fecha inicial
  const [estado, setEstado] = useState('ALL');
  const [procesoOn, setProcesoOn] = useState(null);


/* 
        _id: data._id,
        tipoDocumento: data.tipoDocumento,
        fechaCreacion: data.fechaCreacion,
        origen: data.origen,
        final: data.final,
        idCliente: data.idCliente,
        rutCliPro: data.rutCliPro,
        usuario: data.usuario,
        estado: data.estado
*/
  const transformDataArray = (dataArray) => {
    return dataArray.map(data => {
      // Extraer campos base
      const baseData = {
        formatoCliente: data.razonSocialCliente,
        rutEmpresa: data.rutEmpresa,
        razonSocial: data.razonSocial,
        fechaConstitucion: data.fechaConstitucion,
        fechaCertificado: data.fechaCertificado,
        sglex: data.sglex,
        tipoSocial: data.tipoSocial
      };
  
      // Transformar campos
      data.campos.forEach(campo => {
        baseData[campo.codigoPatron] = campo.textoResultante;
      });
  
      return baseData;
    });
  };
  

    const handleSubmit = async (e) =>{
        e.preventDefault(); 
        setProcesoOn("GO");
        try 
        {
            const docuData = await getDocumentosMatriz("RES",selectedDate.toISOString(),selectedDateEnd.toISOString(),estado );


            const salidaArray = transformDataArray(docuData);


            exportToExcel(salidaArray, 'Documentos-RES');
            toast.success('Archivo Excel con Documentos Descargado.');
            setProcesoOn(null);
        } catch (error) {
            console.error("Error al exportar Documentos a Excel", error);
        }
    };

    const BarraModal = ({ processCount, onCancel }) => {
        return (
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center">
            <div className="bg-white p-4 rounded-lg">
              <div className="grid grid-cols-1 gap-4">
                <div className="flex flex-col">
                  <p className="text-sm text-blue-900 bg-opacity-75 p-2 rounded-lg mb-2">
                    PROCESANDO ... {/*processCount*/}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-1 gap-4">
                <div className="flex flex-col">
                  <Button
                    color="white"
                    bgColor={currentColor}
                    text="Cancelar"
                    size="sm"
                    borderRadius="10px"
                    width="full"
                    handleClick={onCancel}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      };

    const calcularPrimerDiaMesAnterior = (startDate) => {
      // Parsea la fecha de inicio
      const fechaInicio = new Date(startDate);
      
      // Obtiene el primer día del mes anterior
      const primerDiaMesAnterior = startOfMonth(subMonths(fechaInicio, 1));
      
      // Formatea la fecha al formato deseado (ej. 01-09-2023)
      const formatoFecha = `${primerDiaMesAnterior.getFullYear()}${('0' + (primerDiaMesAnterior.getMonth() + 1)).slice(-2)}${('0' + primerDiaMesAnterior.getDate()).slice(-2)}`;
    
      return formatoFecha;
    };
    
    const cambiaFecha = (startDate) => {
      // Parsea la fecha de inicio
      const fechaInicio = new Date(startDate);
      
      // Formatea la fecha al formato deseado (ej. 01-09-2023)
      const formatoFecha = `${fechaInicio.getFullYear()}${('0' + (fechaInicio.getMonth() + 1)).slice(-2)}${('0' + fechaInicio.getDate()).slice(-2)}`;
    
      return formatoFecha;
    };

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    if(Como === 'Inicio') return firstDay;
    if(Como === 'Fin') return today;
    if(Como === 'Nada') return null;
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleDateChangeEnd = (date) => {
    setSelectedDateEnd(date);
  };

  const handleChangeEstado = (e) =>{
    setEstado( e.target.value );
  }

  const handleCancelViewer = () => {
    setProcesoOn(null);
  };

  return (

    <div className="m-2 md:m-10 mt-20 p-2 md:p-10 bg-white rounded-3xl">

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4" >
                  <div className="flex flex-col">
                  <p className="text-xs text-gray-600"> Desde </p>
                    <SeleccionaFecha
                      selectedDate={selectedDate}
                      handleDateChange={handleDateChange}
                    />
                  </div>  
                  <div className="flex flex-col">
                  <p className="text-xs text-gray-600"> Hasta </p>
                    <SeleccionaFecha
                      selectedDate={selectedDateEnd}
                      handleDateChange={handleDateChangeEnd}
                    />
                  </div>  

                  <div className="flex flex-col">
                      <p className="text-xs text-gray-600"> Estado </p>
                      <select className="text-xs border-gray-200 outline-none border-2 p-2  focus:border-gray-300" name="estado" value= {estado} required onChange={handleChangeEstado}>   
                      <option value="ALL">Todos</option>
                      <option value="Pendiente">Pendiente</option>
                      <option value="Generado">Generado</option>  
                      <option value="Revisado">Revisado</option>   
                      <option value="Entregado">Entregado</option>    
                      </select>
                  </div>  
                  <div className="flex flex-col">
                      <p className="text-xs text-gray-600"> &nbsp; </p>
                      <Button
                        color="white"
                        bgColor={currentColor}
                        text= "Generar"  
                        borderRadius = "10px"
                        handleClick = {handleSubmit}
                        width = "full"
                      />   
                  </div>
            </div>
            {procesoOn && <BarraModal processCount={0} onCancel={handleCancelViewer} />}
        </div>
  );
};

export default ReporteDocumentos;